export const getAssetUrl = (asset, protocol = 'https') => {
    var _a, _b;
    if (!((_b = (_a = asset === null || asset === void 0 ? void 0 : asset.fields) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.url))
        return '';
    const url = asset.fields.file.url;
    return url.startsWith('//') ? `${protocol}:${url}` : url;
};
export const getAssetDimensions = (asset) => {
    var _a, _b, _c;
    if (!((_c = (_b = (_a = asset === null || asset === void 0 ? void 0 : asset.fields) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.image))
        return null;
    return {
        width: asset.fields.file.details.image.width,
        height: asset.fields.file.details.image.height,
    };
};
export const getAssetSize = (asset) => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = asset === null || asset === void 0 ? void 0 : asset.fields) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.size) || 0;
};
export const formatFileSize = (bytes) => {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
export const isComponentType = (component, contentType) => {
    return component.sys.contentType.sys.id === contentType;
};
export const filterComponentsByType = (components, contentType) => {
    return components.filter((component) => isComponentType(component, contentType));
};
export const findComponentByType = (components, contentType) => {
    return components.find((component) => isComponentType(component, contentType));
};
export const getUniqueContentTypes = (components) => {
    const types = components.map((component) => component.sys.contentType.sys.id);
    return Array.from(new Set(types));
};
export const getComponentField = (component, fieldPath, defaultValue) => {
    const keys = fieldPath.split('.');
    let value = component;
    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            value = value[key];
        }
        else {
            return defaultValue;
        }
    }
    return value;
};
export const createSlug = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
